/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Export_End_Time_SmpteInputs */

const en_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End Time (SMPTE)`)
};

const fr_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heure de fin (SMPTE)`)
};

const de_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endzeit (SMPTE)`)
};

const it_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ora di fine (SMPTE)`)
};

const ru_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время окончания (SMPTE)`)
};

const es_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de finalización (SMPTE)`)
};

const zh_cn2_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结束时间（SMPTE）`)
};

const ja_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終了時刻（SMPTE）`)
};

const hi_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समाप्ति समय (एसएमपीटीई)`)
};

const pt_pt2_markers_export_end_time_smpte = /** @type {(inputs: Markers_Export_End_Time_SmpteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora de término (SMPTE)`)
};

/**
* | output |
* | --- |
* | "End Time (SMPTE)" |
*
* @param {Markers_Export_End_Time_SmpteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_export_end_time_smpte = /** @type {((inputs?: Markers_Export_End_Time_SmpteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Export_End_Time_SmpteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_export_end_time_smpte(inputs)
	if (locale === "de") return de_markers_export_end_time_smpte(inputs)
	if (locale === "it") return it_markers_export_end_time_smpte(inputs)
	if (locale === "ru") return ru_markers_export_end_time_smpte(inputs)
	if (locale === "es") return es_markers_export_end_time_smpte(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_export_end_time_smpte(inputs)
	if (locale === "ja") return ja_markers_export_end_time_smpte(inputs)
	if (locale === "hi") return hi_markers_export_end_time_smpte(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_export_end_time_smpte(inputs)
	return en_markers_export_end_time_smpte(inputs)
});